import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

import { stylisticFont, truefilesColor } from './constants';

const solid = defineStyle((props) => ({
  background: truefilesColor,
  color: 'white',
  padding: '0px 25px',
  height: '55px',
  borderRadius: '30px 30px 0px 30px',
  _hover: {
    background: truefilesColor,
  },
  fontSize: '16px',
  fontWeight: '600',
}));

const outline = defineStyle({
  borderColor: truefilesColor,
  color: 'white',
  borderRadius: '8px',
  borderWidth: '2px',
  px: '25px',
});

const login = defineStyle({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '7px',
  width: '100%',
  height: '55px',
  mt: '25px',
  borderRadius: '12px',
  bgColor: truefilesColor,
  color: 'white',
  fontWeight: '600',
  fontSize: '16px',
  fontFamily: stylisticFont,
});

export const buttonTheme = defineStyleConfig({
  baseStyle: {
    fontFamily: stylisticFont,
  },
  defaultProps: {
    variant: 'solid',
  },
  variants: {
    login,
    solid,
    outline,
  },
});
